module.exports = __webpack_public_path__ + "static/sigma-1-052081fae0462937feff9492bff6f804.jpeg";